import { FC } from "react";
import styled from "styled-components";
import { useFormatPercent } from "../hooks/useFormatPercent";
import { EvaluatedFeedbackChoiceQuestionResource } from "../types/feedback";

const Grid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: ${({ theme }) => theme.spacing(2)};
`;

interface Props {
	question: EvaluatedFeedbackChoiceQuestionResource;
}
export const CompactFeedbackChoiceQuestionEvaluation: FC<Props> = ({ question }) => {
	const formatPercent = useFormatPercent();
	return (
		<Grid>
			{question.answerOptions.map((answerOption) => {
				const numberOfSelections =
					question.evaluation.answerOptions.find((option) => option.id === answerOption.id)?.numberOfSelections || 0;
				return (
					<span key={answerOption.id}>
						{answerOption.text}: {numberOfSelections} (
						{formatPercent(
							question.evaluation.totalAnswers > 0 ? numberOfSelections / question.evaluation.totalAnswers : 0,
						)}
						)
					</span>
				);
			})}
		</Grid>
	);
};
